module.exports = __webpack_public_path__ + "media/images/emblems/Courchavon-coat_of_arms-434000e0f5f5684ac175516201282e5e.svg";